import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { DocumentIndex } from '@/interfaces/documentIndex';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentGenerateRoute: RouteConfig = {
  path: 'generate',
  name: 'documentGenerate',
  component: () => import(/* webpackChunkName: "DocumentGenerate" */ '@/views/mainRoute/document/details/Generate.vue'),
  meta: { breadcrumb: { title: 'Generowanie dokumentacji' } },
  beforeEnter: (to, from, next) => {
    store.commit('documentIndex/setId', tryParseInt(to.params.documentId));
    Promise.all([
      store
        .dispatch('documentIndex/get')
        .then((document: DocumentIndex) => store.dispatch('view/listByStatusOption', { statusId: document.statusId })),
      store.dispatch('document/attachment/list', {
        order: 'order',
        desc: false,
        count: -1,
        entityType: EntityType.DOCUMENT,
        entityId: to.params.documentId.toString()
      })
    ]).then(() => next());
  }
};
